
import { Component, Vue, Watch } from 'vue-property-decorator'
import ImagePreview from '@/views/goodsManage/commodity/template/ImagePreview.vue'
import draggable from 'vuedraggable'
import { FileDTO, upFile, fileTypes } from '@/api/commonConfig'
import { goodsImageDto } from '@/api/goods'
import { downloadUrl } from '@/utils/util'
import { Action, Getter } from "vuex-class";
import { goodsBannerImage } from '@/constant/event'
import { chooseFile } from '@/utils/h5ToApp'

@Component({
  components: {
    draggable,
    ImagePreview
  }
})
export default class GoodsImageInfo extends Vue {
  @Getter companyId!: string
  downloadUrl = downloadUrl
  imageList: goodsImageDto[] = []
  fileList: FileDTO[] = []
  videoFileList: FileDTO[] = []
  video = {
    goodsVideoUrl: '',
    goodsVideoBase64Url: '',
    goodsVideoSize: null
  }

  @Watch('imageList', { deep: true })
  onImageList () {
    this.imageList.forEach((image, index) => {
      image.serialNumber = index + 1
    })
    this.$eventBus.$emit(goodsBannerImage, this.imageList)
  }

  // afterRead (file: any) {
  //   const formData = new FormData()
  //   formData.append('fileStream', file)
  //   formData.append('fileType', fileTypes.goodsBanner)
  //   upFile(formData).then((res) => {
  //     const file = res.data
  //     this.imageList.push({
  //       serialNumber: this.imageList.length + 1,
  //       imageUrl: file.filePath,
  //       imageBase64Url: downloadUrl(file.filePath),
  //       imageSize: file.fileSize
  //     })
  //   })
  //   return true
  // }

  afterRead () {
    // const data = {
    //   companyId: this.companyId,
    //   // 上传文件类别 1公司log 2商品轮播图 3商品推荐图 4商品视频 5商品内容HTML文件 6订单附件
    //   fileType: fileTypes.goodsBanner,
    // }
    // this.$bridge.callHandler('uploadFile', data, (res) => {
    //   const data = !res ? {} : JSON.parse(res)
    //   // let nameArr = data.filePath.split('/')
    //   // this.orderInfo.orderFileName = nameArr.pop()
    //   console.log(data)
    //   this.imageList.push({
    //     serialNumber: this.imageList.length + 1,
    //     imageUrl: data.filePath,
    //     imageBase64Url: downloadUrl(data.filePath),
    //     imageSize: data.fileSize
    //   })
    // })
    const  data = {
      fileType:'1',
      maxFileCount:'7'
    }
    chooseFile(data).then((res:any)=> {
      this.imageList = res.map((item:{[x:string]:any}) => {
        return {
        serialNumber: item.serialNumber,
        imageUrl: item.filePath,
        imageBase64Url: downloadUrl(item.filePath),
        imageSize: item.fileSize
        }
      })
      
    })
  }

  // afterReadVideo (file: FileDTO) {
  //   const formData = new FormData()
  //   formData.append('fileStream', file.file)
  //   formData.append('fileType', fileTypes.goodsVideo)
  //   upFile(formData).then((res) => {
  //     const file = res.data
  //     this.video.goodsVideoUrl = file.filePath
  //     this.video.goodsVideoSize = file.fileSize
  //   })
  // }
  beforeRead (file: FileDTO) {
    return true
  }
  deleteImage (index: number) {
    this.imageList.splice(index, 1)
  }
  setData (goodsImageList: goodsImageDto[], goodsVideoUrl: string) {
    this.imageList = goodsImageList
    this.video.goodsVideoUrl = goodsVideoUrl
    this.video.goodsVideoBase64Url = downloadUrl(goodsVideoUrl)
    this.fileList = []
    this.imageList.forEach(item => {
      this.fileList.push({
        url: downloadUrl(item.imageUrl)
      })
    })
  }
  handleSubmit () {
    return new Promise((resolve, reject) => {
      // 如果存在校验未通过的情况，阻止提交
      if (document.querySelectorAll('[data-validator]').length) return false
      if (!this.imageList.length) {
        this.$toast('请上传商品相关图片')
        return false
      }
      const imgList = JSON.parse(JSON.stringify(this.imageList))
      imgList.forEach(item => {
        delete item.imageBase64Url
      })
      const video = JSON.parse(JSON.stringify(this.video))
      delete video.goodsVideoBase64Url
      resolve({ imgList, video })
    })
  }
}
